var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeWidth: 130,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.160255, 0, 0, -0.160255, -74.883965, 337.311279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1712 1983 C 1775 1954 1846 1881 1878 1812 C 1905 1755 1905 1755 1908 1470 C 1912 1100 1904 1056 1811 957 C 1752 893 1690 868 1577 860 L 1479 853 L 1378 753 L 1278 653 L 1189 745 C 1139 796 1087 843 1072 848 C 1057 854 1009 860 965 863 C 871 867 806 896 749 957 C 656 1056 647 1104 652 1477 L 655 1757 L 690 1825 C 732 1906 796 1965 872 1991 C 920 2008 957 2010 1295 2007 C 1651 2005 1667 2004 1712 1983 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1019.579 1321.991 C 1642.451 1322.347 1541.098 1324.912 1541.098 1324.912 C 1541.098 1324.912 904.03 1321.925 1019.579 1321.991 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1019.33 1558.93 C 1642.2 1559.3 1540.85 1561.87 1540.85 1561.87 C 1540.85 1561.87 903.783 1558.88 1019.33 1558.93 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.1f5b1061f26b6394dd03dbf3987a254b.svg";
export { ForwardRef as ReactComponent };